<div class="container">
    <div class="gallery-container">
        <div class="image-card" *ngFor="let image of images" (click)="viewImage(image)">
            <!-- <img [src]="image.thumbnail" alt="Image Thumbnail" /> -->
            <div class="image-id"> {{ image.attachmentName }}</div>
        </div>
    </div>
    <div class="image-viewer" *ngIf="selectedImage">
        <img [src]="'data:image/png;base64,' + selectedImage.base64" alt="Full Image" />
        <!-- <textarea readonly>{{ selectedImage.base64 }}</textarea> -->
        <button (click)="close()">Close</button>
    </div>
    <div *ngIf="!selectedImage" class="body" style="display:none">
        <div id="sectionprintolddata">
            <h2 class="my-3">{{translate.currentLang == 'ar' ? 'تتبع سير المريض' : 'Patient Details'}}</h2>
            <div class="wrapper"
                [ngClass]="{'left-to-right': translate.currentLang != 'ar', 'right-to-left': translate.currentLang == 'ar'}">
                <table class="full-width table-custom">
                    <tbody>

                        <tr>
                            <td class="detailBand_ar reportTitle_ar">
                                <strong style="text-decoration: underline;">{{'Name' | translate}}</strong>
                            </td>
                            <td class="detailBand_ar reportTitle_ar">
                                {{translate.currentLang == 'ar' ? patInfo.fullnameAr : patInfo.fullnameEn}}
                            </td>
                            <td class="detailBand_ar reportTitle_ar">
                                <strong style="text-decoration: underline;">{{'CODE' | translate}}</strong>
                            </td>
                            <td class="detailBand_ar reportTitle_ar">{{patInfo.patientCode}}</td>

                        </tr>

                    </tbody>
                </table>

                <div class="row"></div>
                <div class="row"></div>
                <table class="full-width table-custom">
                    <thead>
                        <tr>
                            <th class="groupHeaderLevel1_ar">{{ 'VISITNUMBER' | translate }}</th>
                            <th class="groupHeaderLevel1_ar">{{ 'visitDateTime' | translate }}</th>
                            <th class="groupHeaderLevel1_ar">{{ 'serviceName' | translate }}</th>

                            <th class="groupHeaderLevel1_ar">{{ 'EYE' | translate }}</th>
                            <th class="groupHeaderLevel1_ar">{{ 'visitType' | translate }}</th>

                            <th class="groupHeaderLevel1_ar">{{ 'USER' | translate }}</th>
                            <th class="groupHeaderLevel1_ar">{{ 'doctorName' | translate }}</th>
                            <th class="groupHeaderLevel1_ar">{{ 'branchName' | translate }}</th>

                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let member of regpatHistoryOnOldSystemArr;">

                            <td class="detailBand_ar reportTitle_ar">{{member.visitCode}}</td>
                            <td class="detailBand_ar reportTitle_ar">{{member.visitDateTime}}</td>
                            <td class="detailBand_ar reportTitle_ar">{{translate.currentLang == 'ar'?
                                member.serviceNameAr : member.serviceNameEn }}</td>

                            <td class="detailBand_ar reportTitle_ar">{{translate.currentLang == 'ar'? member.eyeAr :
                                member.eyeEn }}</td>
                            <td class="detailBand_ar reportTitle_ar">{{translate.currentLang == 'ar'? member.visitTypeAr
                                : member.visitTypeEn }}</td>

                            <td class="detailBand_ar reportTitle_ar">{{translate.currentLang == 'ar'? member.userNameAr
                                : member.userNameEn }}</td>
                            <td class="detailBand_ar reportTitle_ar">{{translate.currentLang == 'ar'?
                                member.doctorNameAr : member.doctorNameEn }}</td>
                            <td class="detailBand_ar reportTitle_ar">{{translate.currentLang == 'ar'?
                                member.branchNameAr : member.branchNameEn }}</td>

                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <app-print-page *ngIf="!selectedImage" #printComponent section="sectionprintolddata"></app-print-page>
   
</div>




<style>
    .tbt {
        box-shadow: 0 0 5px 0px rgba(0, 0, 0, 0.25);
        border-radius: 7px 7px 20px 20px;
    }

    .tbt td {
        vertical-align: middle !important;
        color: #25b982 !important;
    }

    .tbt th {
        color: teal !important;
        padding-left: 25px;
        padding-right: 25px;
    }

    .cvc::after {
        background-color: #25b982 !important;
    }

    .gallery-container {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
        gap: 16px;
        padding: 16px;
    }

    .image-card {
        cursor: pointer;
        border: 1px solid #ddd;
        border-radius: 8px;
        overflow: hidden;
        text-align: center;
    }

    .image-card img {
        width: 100%;
        height: auto;
    }

    .image-id {
        padding: 8px;
        font-size: 14px;
        background: #f9f9f9;
    }
</style>